<div class="formgrid grid">
  <div class="field lg:col-6 col-12">
    <label class="font-medium required-field">Тип</label>
    <crm-deadline-type-single-select
      [(type)]="planning.type"
      [class]="errors?.type ? 'ng-invalid ng-dirty' : ''"
      styleClass="w-full {{ errors?.type ? 'ng-invalid ng-dirty' : '' }}"
      [appendTo]="appendTo"></crm-deadline-type-single-select>
    <small
      *ngIf="errors?.type"
      class="p-error">
      {{ errors.type | join }}
    </small>
  </div>

  <div
    *ngIf="planning?.type === DeadlineTypeEnum.RELATIVE"
    class="field lg:col-6 col-12">
    <label class="font-medium required-field">Дата дедлайна</label>
    <p-inputNumber
      [(ngModel)]="planning.daysAfter"
      [min]="0"
      [ngClass]="{ 'ng-invalid ng-dirty': errors?.daysAfter }"
      styleClass="w-full"
      prefix="Через "
      suffix=" дн."
      class="w-full"></p-inputNumber>
    <small
      *ngIf="errors?.daysAfter"
      class="p-error">
      {{ errors.daysAfter | join }}
    </small>
  </div>

  <div
    *ngIf="planning?.type === DeadlineTypeEnum.ABSOLUTE"
    class="field lg:col-6 col-12">
    <label class="font-medium required-field">Тип месяца</label>
    <crm-deadline-month-type-single-select
      [(type)]="planning.monthType"
      [class]="errors?.monthType ? 'ng-invalid ng-dirty' : ''"
      styleClass="w-full {{ errors?.monthType ? 'ng-invalid ng-dirty' : '' }}"
      [appendTo]="appendTo"></crm-deadline-month-type-single-select>
    <small
      *ngIf="errors?.monthType"
      class="p-error">
      {{ errors.monthType | join }}
    </small>
  </div>

  <div
    *ngIf="planning?.type === DeadlineTypeEnum.ABSOLUTE"
    class="field lg:col-6 col-12">
    <label class="font-medium required-field">Число месяца</label>
    <p-inputNumber
      [(ngModel)]="planning.dayOfMonth"
      [max]="31"
      [min]="1"
      [ngClass]="{ 'ng-invalid ng-dirty': errors?.dayOfMonth }"
      styleClass="w-full"
      class="w-full"></p-inputNumber>
    <small
      *ngIf="errors?.dayOfMonth"
      class="p-error">
      {{ errors.dayOfMonth | join }}
    </small>
  </div>
</div>
